// extracted by mini-css-extract-plugin
export default {"root":"ZFBN5dLftvhXeECcts8g","label":"jfnTjinxBit3PzFD1xZC","dropdown":"CfhcPqi06XKUmWr9WmW7"};